import {ObjectTransformation} from './ObjectTransformation';
import {WallCutService} from '../../../wall/wall-cut.service';

export class WallObjectTransformation extends ObjectTransformation {

  constructor(object, private wallCutSrvc: WallCutService) {
    super(object);
  }

  restoreTransformation() {
    super.restoreTransformation();
    this.wallCutSrvc.cutHoles(this.object.parent);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/common/ObjectTransformation/WallObjectTransformation.ts